import React from 'react'

const Setting = ({ handleSubmit, handleChange, loading, group }) => {
    const entityLabel = group?.type === 'company' ? 'company' : 'group';
    const EntityLabel = group?.type === 'company' ? 'Company' : 'Group';

    return (
        <div className="group-settings-container">
            <h2 className="group-settings-header">Change {EntityLabel} Settings</h2>
            <div className="group-settings-section">
                <h3 className="group-settings-title">Privacy Options</h3>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} name="privacy" value="public" className="group-settings-radio" checked={group.privacy === 'public'} />
                    This is a public {entityLabel}
                    <ul className="group-settings-details">
                        <li>Any site member can join this {entityLabel}.</li>
                        <li>This {entityLabel} will be listed in the directory and in search results.</li>
                        <li>{EntityLabel} content and activity will be visible to any site member.</li>
                    </ul>
                </label>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} name="privacy" value="private" className="group-settings-radio" checked={group.privacy === 'private'} />
                    This is a private {entityLabel}
                    <ul className="group-settings-details">
                        <li>Only people who request membership and are accepted can join the {entityLabel}.</li>
                        <li>This {entityLabel} will be listed in the directory and in search results.</li>
                        <li>{EntityLabel} content and activity will only be visible to followers.</li>
                    </ul>
                </label>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} name="privacy" value="hidden" className="group-settings-radio" checked={group.privacy === 'hidden'}/>
                    This is a hidden {entityLabel}
                    <ul className="group-settings-details">
                        <li>Only people who are invited can join the {entityLabel}.</li>
                        <li>This {entityLabel} will not be listed in the directory or search results.</li>
                        <li>{EntityLabel} content and activity will only be visible to followers.</li>
                    </ul>
                </label>
            </div>
            <div className="group-settings-section">
                <h3 className="group-settings-title">{EntityLabel} Invitations</h3>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} checked={group.invitation === 'anyone'} value="anyone" name="invitation" className="group-settings-radio" />
                    All {entityLabel} followers
                </label>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} checked={group.invitation === 'invite_only'} value="invite_only" name="invitation" className="group-settings-radio" />
                    {EntityLabel} admins and mods only
                </label>
                <label className="group-settings-option">
                    <input type="radio" onChange={handleChange} checked={group.invitation === 'admin_only'} value="admin_only" name="invitation" className="group-settings-radio" />
                    {EntityLabel} admins only
                </label>
            </div>
            <button onClick={handleSubmit} className='btncs px-5'>{loading ? 'Saving...' : 'Save'}</button>
        </div>
    )
}

export default Setting
